





































































import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListKanriHimmoku',
  components: {
    CtrlSearchCommonComponents,
    CtrlDatePicker,
    CtrlMessageDialog,
  },
  props: {
    targetYmd: {
      type: Number,
      required: true,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'shushiHimmokuCd',
        width: 51,
      },
      {
        text: '名称',
        sortable: true,
        value: 'shushiHimmokuMei',
        width: 187,
      },
    ],
    formatColName: 'shushiHimmokuCd',
    targetYmdRef: '',
    shushiHimmokuMei: '',
    filterGroupKey: 0,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
  }),
  methods: {
    setupTargetYmd() {
      this.targetYmdRef = this.targetYmd + '';
    },
    onChangeDate(date: string) {
      if (!date) this.targetYmdRef = '';
      this.targetYmdRef = date.replaceAll('-', '');
    },
    validateDate(callbackGetData: any, callbackListClear: any) {
      if (!this.targetYmdRef) {
        this.messageShow = true;
        this.messageId = 'KI_W100';
        this.messageTextParam = ['摘要開始日'] as never;
        callbackListClear();
        return;
      } else {
        callbackGetData();
      }
    },
    resetData() {
      this.setupTargetYmd();
      // Increment to refresh form
      this.filterGroupKey += 1;
    },
  },
  created() {
    this.setupTargetYmd();
  },
});
